const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/portfolio/swimlane/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { mergedPortfolioViewBeforeLoad } from '@/features/portfolio/utils/merged-portfolio/combinedTabRouteGuards';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio/swimlane/')({
  beforeLoad: mergedPortfolioViewBeforeLoad,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});